import { render, staticRenderFns } from "./survey.vue?vue&type=template&id=9e3a4ac8&scoped=true"
import script from "./survey.vue?vue&type=script&lang=js"
export * from "./survey.vue?vue&type=script&lang=js"
import style0 from "./survey.vue?vue&type=style&index=0&id=9e3a4ac8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e3a4ac8",
  null
  
)

export default component.exports